import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { Typography, Box, Button, Table, TableRow, TableBody, TableCell, TableContainer, Paper, TableHead, TextField, Grid } from "@mui/material";
import "./dotsStyles.css"
import { keyframes } from "@mui/material";
function LoadingDots(props) {
  const { t } = useTranslation();



  return (
      <div className="bouncing-loader" style={{display:"flex",height:"48px",marginTop: "20px "}}>
        <div></div>
        <div></div>
        <div></div>
      </div>
  );
}
export default LoadingDots;
